import moment from "moment";
// migrated
// export class Time extends Date {
export class Time {
    hour: number
    minute: number

    constructor(hour: number, minute: number) {
        // migrated
        // super(0,0,0, hour, minute, 0)
        this.hour = hour
        this.minute = minute
    }

    toString(): string {        
        return moment(this).format("HH:mm")
    }
}

export class HoursOfOperation {
    weekDay: number
    opensAt: Time
    closesAt: Time

    constructor(weekDay: number, opensAt: Time, closesAt: Time) {
        this.weekDay = weekDay
        this.opensAt = opensAt
        this.closesAt = closesAt
    }
}
